import { isCheckInGateRule } from './is-check-in-gate-rule.js';
export function hasCheckInGate(checkInRequired, rules) {
    return checkInRequired || (rules?.some(isCheckInGateRule) ?? false);
}
//# sourceMappingURL=has-check-in-gate.js.map